module.exports = __webpack_public_path__ + "static/media/logo.2e2356da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/brand/logo.svg
// module id = 700
// module chunks = 0